module.exports = __webpack_public_path__ + "img/salty-4.eab535f3.webp";